var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"transform":"translate(-284.000000, -22.000000)","stroke":"#142B6F","strokeWidth":"2"},React.createElement("g",null,React.createElement("g",{"transform":"translate(284.000000, 22.000000)"},React.createElement("path",{"d":"M14,14 L2,2 L14,14 Z M14,2 L2,14 L14,2 Z"}))))));
}

IconClose.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = IconClose;

IconClose.default = IconClose;
